export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10843.fe6b61c3.jpg";